import AuthorizationInfo from './authorizationsInfo';
import TemporaryAuthorizationsInfo from './temporaryAuthorizationsInfo';
import FlaggedSessions from './flaggedSessions';

const AdminDashboard = () => (
	<div>
		<div className="dashboardSessionInfoSection">
			<AuthorizationInfo />
			<TemporaryAuthorizationsInfo />
		</div>
		<FlaggedSessions />
	</div>
);

export default AdminDashboard;
